import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableInsurancePromoExtended = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableInsurancePromoExtended);
};
